export const useDynamicEvents = () => {
  const buildDynamicFilterProps = (filters: any[], showInchValues: boolean, tv: any): Record<string, any> => {
    const props: Record<string, string> = {}
    filters.filter(f => f.isCoreFilter)
      .forEach(filter => {
        const val = filter.activeValues
        if (val !== null && val !== undefined) {
          if (Array.isArray(val)) {
            props[filter.shortName] = val.join(', ')
          } else if (typeof val === 'object') {
            props[filter.shortName] = filter?.text.replace(/<[^>]+>/g, '').match(/[\d.]+\s+\+\/-[\d.]+\s+\w+/)?.[0].replace(/\s+/g, ' ')
          } else {
            props[filter.shortName] = String(val)
          }
        }
      })
    props['unitOfMeasure'] = !showInchValues ? tv('metricInchToggleLeftText', 'product') : tv('metricInchToggleRightText', 'product')
    return props
  }

  const serializeValue = (value: any): string => {
    if (value === null || value === undefined) {
      return ''
    }
    if (Array.isArray(value)) {
      return value
        .map(item => (item !== null && typeof item === 'object' ? serializeObject(item) : String(item)))
        .join(',')
    }
    if (typeof value === 'object') {
      return serializeObject(value)
    }
    return String(value)
  }

  const serializeObject = (obj: Record<string, any>): string => {
    return Object.entries(obj)
      .filter(([, v]) => v !== null && v !== undefined && typeof v !== 'object')
      .map(([k, v]) => `${k}:${v}`)
      .join(';')
  }

  const buildDynamicProductProps = (product: Record<string, any>, propsKeys: string[]): Record<string, any> => {
    const props: Record<string, string> = {}
    for (const [key, value] of Object.entries(product)) {
      if (propsKeys.includes(key) && value !== null && value !== undefined) {
        props[key] = serializeValue(value)
      }
    }
    return props
  }

  return {
    buildDynamicFilterProps,
    buildDynamicProductProps
  }
}
